import { FilterSection } from 'components/shared/filters/FilterSlideout';
import {
  DISCHARGED_DROPDOWN,
  HAS_NEW_CHANGES_CHECKBOX,
  PLAN_TYPE_DROPDOWN,
  RECEIVED_REFERRED_TO_DROPDOWN,
  REFERRED_BY_DROPDOWN,
  REVIEW_STATUS_DROPDOWN,
  SENT_REFERRED_BY_DROPDOWN,
  sentReferredToDropdown,
} from 'constants/filterConfigs';
import Client from 'models/Client';

export function getFilterSections({ client }: { client: Client }): FilterSection[] {
  const { sendsReferrals } = client;

  return [
    {
      title: 'Filters',
      filters: [
        PLAN_TYPE_DROPDOWN,
        sendsReferrals ? SENT_REFERRED_BY_DROPDOWN : REFERRED_BY_DROPDOWN,
        sendsReferrals ? sentReferredToDropdown(client) : RECEIVED_REFERRED_TO_DROPDOWN,
        REVIEW_STATUS_DROPDOWN,
        ...(sendsReferrals ? [DISCHARGED_DROPDOWN] : []),
        HAS_NEW_CHANGES_CHECKBOX,
      ],
    },
  ];
}
